import { render, staticRenderFns } from "./RelatedProductsSearchField.vue?vue&type=template&id=71a7d78e&"
import script from "./RelatedProductsSearchField.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsSearchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports